import axiosInstance from "../axiosInstance";
import axios from 'axios';

const apigeeDomain = process.env.REACT_APP_APIGEE_API_DM;

const getAccessToken = () => {
    //apigee access token api call
    let access_token = ''
    const username = process.env.REACT_APP_APIGEE_OAUTH_EMAIL;
    const password = process.env.REACT_APP_APIGEE_OAUTH_PASSWORD;


    return axios.post(process.env.REACT_APP_APIGEE_API_DM + process.env.REACT_APP_APIGEE_OAUTH_API, {}, {
        headers: {
            "Content-Type": 'application/x-www-form-urlencoded',
            "Access-Control-Allow-Origin": "*"
        },
        auth: {
            "username": username,
            "password": password
        }
    })
}

const getRefreshToken = async (accessToken, secretToken) => {
    return axios.post(process.env.REACT_APP_APIGEE_API_DM + process.env.REACT_APP_API_REFRESH_TOKEN, {}, {
        headers: {
            "Authorization": accessToken,
            "tdb-token": secretToken,
        }
    })
}

const sendLoginUser = (inputData, accessToken) => {
    const headers = {
        headers: {
            'Authorization': accessToken
        }
    };
    const URL = apigeeDomain + process.env.REACT_APP_API_LOGIN;
    return axios.post(URL, inputData, headers)
}

const sendLogoutUser = () => {
    const URL = apigeeDomain + process.env.REACT_APP_API_LOGOUT;
    return axiosInstance.post(URL);
}

const sendPasswordUpdate = (inputData) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_USER;
    return axiosInstance.patch(URL, inputData)
}


export { getAccessToken, getRefreshToken, sendLogoutUser, sendLoginUser, sendPasswordUpdate };